import { TicketErrorController } from './ticketError.controller';
import template from './ticketError.html';

export const ticketErrorComponent = {
  name: 'ticketErrorComponent',
  restrict: 'E',
  template,
  controller: TicketErrorController,
  controllerAs: 'vm',
  bindings: {}
};
